import React, { useContext, useState } from "react"
import tw, { styled } from "twin.macro"
import { EmojiReaction, QuestionDetailFragment } from "../../graphql/generated/graphql"
import { EmojiPanelProps } from "./emojiPanel"
import { AuthContext } from "../../utils/context"
import { AddReaction } from "./addReaction"
import { WhoReacted, WhoReactedProps } from "./whoReacted"

type Reaction = {
  key: EmojiReaction
  value: string
}

export const emojis = new Array<Reaction>(
  { key: EmojiReaction.Heart, value: "❤️" },
  { key: EmojiReaction.Joy, value: "😂️" },
  { key: EmojiReaction.Astonished, value: "😮" },
  { key: EmojiReaction.Pensive, value: "😔" },
  { key: EmojiReaction.Sparkles, value: "✨" },
)

export const getEmojiForReaction = (key: string): string | undefined => {
  const hit = emojis.find((reaction) => reaction.key === key)
  return hit?.value
}

interface EmojiPanelWrapperProps {
  isOpen: boolean
}
export const EmojiPanelWrapper = styled("div")(({ isOpen }: EmojiPanelWrapperProps) => [
  tw`p-2.5 flex gap-4 bg-white text-3xl z-10 opacity-0`,
  tw`border border-base-2 border-solid rounded`,
  tw`absolute -top-20`,
  tw`transition-opacity duration-150 invisible`,
  isOpen && [tw`!opacity-100 visible`],
])

interface EmojiReactionsProps {
  question: QuestionDetailFragment
  refetchQuestion?: () => Promise<Record<string, any>>
  useEmojiSmall: boolean
  isReactable: boolean
}

export const EmojiReactions = (props: EmojiReactionsProps) => {
  const { userId } = useContext(AuthContext)
  const { question, refetchQuestion, isReactable, useEmojiSmall } = props
  const { Artist, reactions } = question
  const userReaction = reactions.find((reaction) => reaction.Reactor.id === userId)
  const artistReaction = reactions.find((reaction) => reaction.Reactor.id === Artist.id)
  const isArtist = userId === Artist.id
  const [userEmoji, setUserEmoji] = useState<EmojiReaction | undefined>(
    isArtist ? artistReaction?.emoji : userReaction?.emoji,
  )
  const [showAllReactions, setShowAllReactions] = useState(false)
  const [showEmojiPanel, setShowEmojiPanel] = useState(false)

  const whoReactedProps: WhoReactedProps = {
    question,
    showAllReactions,
    setShowAllReactions,
    useEmojiSmall,
  }

  if (refetchQuestion && isReactable) {
    const addReactionProps: EmojiPanelProps = {
      questionId: question.id,
      userEmoji,
      setUserEmoji,
      showEmojiPanel,
      setShowEmojiPanel,
      refetchQuestion,
    }
    return (
      <div tw="flex items-center w-full " css={[isReactable ? tw`space-x-2` : tw`space-x-5`]}>
        <AddReaction {...addReactionProps} />
        <WhoReacted {...whoReactedProps} />
      </div>
    )
  }
  return (
    <div tw="flex items-center w-full " css={[isReactable ? tw`space-x-2` : tw`space-x-5`]}>
      <WhoReacted {...whoReactedProps} />
    </div>
  )
}
